import { latestReleaseNote } from '~/app/UserSupportDialog/releaseNote'
import { useFlag } from '~/hooks/useFlag'
import { useStore } from '~/store/store'
import { trackUserEvent } from '~/utils/analytics'

const LOCAL_STORAGE_KEY = 'hero_release_note_seen_id'

// via localstorage we keep track of an incremental id of which change log the user has seen/dismissed
export function readReleaseNoteSeenId(): number | null {
    const item = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (item) {
        const result = parseInt(item)
        if (!isNaN(result)) {
            return result
        }
    }
    return null
}

function setSeenId(id: number): void {
    localStorage.setItem(LOCAL_STORAGE_KEY, String(id))
}

export function useReleaseNote() {
    const isReleaseNotesDialogOpen = useStore(state => state.app.isReleaseNoteDialogOpen)
    const setIsReleaseNoteDialogOpenInStore = useStore(state => state.app.actions.setIsReleaseNotesDialogOpen)
    const seenId = useStore(state => state.app.lastReleaseNoteSeen)
    const setLastReleaseNoteSeen = useStore(state => state.app.actions.setLastReleaseNoteSeen)

    if (!useFlag('help__change_log_menu')) {
        return {
            newReleaseNote: null,
            markReleaseNoteAsSeen: () => {},
            isReleaseNoteDialogOpen: false,
            setIsReleaseNotesDialogOpen: () => {},
        }
    }

    const newReleaseNote = latestReleaseNote !== null && (seenId === null || seenId < latestReleaseNote.id) ? latestReleaseNote : null

    function markReleaseNoteAsSeen({ trackEvent }: { trackEvent: boolean } = { trackEvent: true }) {
        if (latestReleaseNote !== null) {
            setSeenId(latestReleaseNote.id)
            setLastReleaseNoteSeen(latestReleaseNote.id)
        }
        if (trackEvent) {
            trackUserEvent('RELEASE_NOTE_MARK_SEEN', { releaseNoteId: newReleaseNote?.id ?? -1 })
        }
    }
    function debug_markReleaseNotesAsUnseen() {
        setLastReleaseNoteSeen(NaN)
        setSeenId(NaN)
        window.location.reload()
    }
    function setIsReleaseNotesDialogOpen(isReleaseNotesDialogOpen: boolean) {
        if (isReleaseNotesDialogOpen) {
            markReleaseNoteAsSeen({ trackEvent: false }) // because we already track the dialog-open event
        }
        setIsReleaseNoteDialogOpenInStore(isReleaseNotesDialogOpen)
        trackUserEvent('RELEASE_NOTE_DIALOG_OPEN', { releaseNoteId: newReleaseNote?.id ?? -1 })
    }

    return { newReleaseNote, markReleaseNoteAsSeen, isReleaseNotesDialogOpen, setIsReleaseNotesDialogOpen, debug_markReleaseNotesAsUnseen }
}
